<template>
    <sweet-modal :title="$Jed.firstUpperTranslate('pick %1$s', null, {key: 'index'})" 
    hide-close-button :blocking="doBlock" overlay-theme="dark" ref="modal"> <!-- modal-theme="dark"  -->
        <!--
        <div id="step_wrapper">
            <dyn-steps :iterated="steps" :activeStep="step" idProp="ID" :showed="stepLabel" :showedValue="stepValue" :visibles="visibles"
            :wrStyle="{margin: '15px 10px', 'box-shadow': '2px 3px 2px rgba(0, 0, 0, 1)'}"></dyn-steps>

        </div>
        -->
        <!-- :backTo1Allowed="$Configs.idAgente != 'null'" --> 
        <transition name="fade" tag="div" style="padding: 0px 32px;">
            <component :is="step_component" @forward="stepForward" @manuallyOpenCallback="registerCallback" @tryOpenModal="tryOpenModal"
            :backTo1Allowed="previousExist" @load="load" @backward="navBackward" :isAfterLogin="doBlock"
            :machineID="childrenContent.machineID" :modelID="childrenContent.modelID" :exOnOpen="exOnOpen"
            :catalogo="childrenContent.catalogo" :modello="childrenContent.modello"></component>
            
        </transition>
    </sweet-modal>
</template>
<script>
import { eventBus } from "../../eventbus.js";
import { SweetModal } from "sweet-modal-vue";

import DynSteps from "../dynamic/DynSteps.vue";
import steps_mixin from "./steps/step_structure_mixin.js";

import SelezionaCliente from "./steps/SelezionaCliente.vue";
import PreSelezione from "./steps/PreSelezione.vue";
import IdentificazioneProdotto from "./steps/IdentificazioneProdotto.vue";
import RegistrazioneProdotto from "./steps/RegistrazioneProdotto.vue";
import MenuProdotto from "./steps/MenuProdotto.vue";
import SelezioneCatalogo from "./steps/SelezioneCatalogo.vue";
import SelezioneModello from "./steps/SelezioneModello.vue";
import ImpostazioneCompatibilità from "./steps/ImpostazioneCompatibilità.vue";

export default {
  components: {
    SweetModal,
    DynSteps,

    //Step Components
    SelezionaCliente,
    PreSelezione,
    IdentificazioneProdotto,
    RegistrazioneProdotto,
    MenuProdotto,
    SelezioneCatalogo,
    SelezioneModello,
    ImpostazioneCompatibilità
  },
  mixins: [steps_mixin],
  created: function() {
    var vm = this;
    eventBus.$on("pickIndex", function() {
      vm.clearData();
      $("#m-wrap > .sweet-modal-overlay").css("visibility", "initial");
      vm.doBlock = false;
      vm.previous_step = [];
      vm.visibles = vm.initVisibles();
      vm.$refs.modal.open();
      
      // EXONOPEN serve per eseguire la callback registrata quando il componente NON è ancora attivo
      vm.exOnOpen = true;
      // FORZO UPLOAD STEP COMPONENT per non aspettare un ciclo di vue (*watch*)
      vm.steps.forEach(function(s) {
        if (s.ID == vm.step) {
          vm.step_component = s.Componente;
        }
      });
      // REG CALLBACK serve per eseguire la callback registrata quando il componente è GIA' attivo
      this.$nextTick(function(){
        if(vm.registeredCallbacks[vm.step_component]){
          vm.registeredCallbacks[vm.step_component]();
        }
      })

      //ricalcolo dimensione colonne tabella selezione catalogo (mettendo l'header fisso c'era il problema delle colonne schiacciate)
      this.$nextTick(() => {
        var $table = $('#catalogsTable'),
            $bodyCells = $table.find('tbody tr:first').children(),
            $headCells = $table.find('thead tr:first').children(),
            colWidth = null,
            colWidthH = null;
        /* console.log($table.find('tbody').width())
        console.log($table.find('thead').width()) */

        // recupero la larghezza delle colonne del tbody
        colWidth = $bodyCells.map(function() {
            return $(this).width();
        }).get();

        //console.log(colWidth) 

        // recupero la larghezza delle colonne del thead
        colWidthH = $headCells.map(function() {
            return $(this).width();
        }).get();

        //console.log(colWidthH)

        /* //somma delle larghezze delle colonne del tbody 
        var colWidthTotal = 0
        $bodyCells.each(function() {
            colWidthTotal += $(this).width();
        })*/
        //console.log(colWidthTotal) 

        //somma delle larghezze delle colonne del thead
        var colWidthTotalH = 0
        $headCells.each(function() {
            colWidthTotalH += $(this).width();
        })
        //console.log(colWidthTotalH)
        
        // imposta la larghezza delle colonne del thead e del body uguali così corrispondono
        $table.find('thead tr').children().each(function(i, v) {
            $(v).width((colWidthH[i]*$table.find('thead').width())/colWidthTotalH);
        }); 
        $table.find('tbody tr').children().each(function(i, v) {
            $(v).width((colWidthH[i]*$table.find('thead').width())/colWidthTotalH);
        });
      })

    });
    eventBus.$on("doneFirstPreferences", this.firstLoad);
  },
  mounted: function() {
    var vm = this;

    //in App.vue, prima di istanziare router-view, stabilisco se al primo login devo mostrare il tab di preferenze prima di caricare il catalogo
    if(this.$root.showPreferencesAfterLogin){
      // in tal caso, l'esecuzione di firstLoad (oer aprire il modal o emettere l'evento di gotIndex), è delegata al termine della scelta delle preferenze (@doneFirstPreferences)
      this.$router.push({ name: 'preferences'})
    } else {
      this.firstLoad();
    }
  },
  data: function() {
    return {
      doBlock: true,
      exOnOpen: false,
      previous_step: [],
      step: null,
      step_component: null,
      childrenContent: {},
      registeredCallbacks: {}
    };
  },
  watch: {
    step: function() {
      var vm = this;
      this.steps.forEach(function(s) {
        if (s.ID == vm.step) {
          vm.step_component = s.Componente;
        }
      });
    }
  },
  computed: {
    getPath: function() {
      return this.committing.nome == this.active.nome
        ? this.committing.nome
        : " ... > " + this.committing.nome;
    },
    previousExist: function() {
      return this.previous_step.length > 0;
    }
  },
  methods: {
    tryOpenModal: function(){
      var vm = this;
      if(vm.visibles[0]==5 && vm.$root.openModalSelect){
        vm.$refs.modal.open();
      }
    },
    registerCallback: function(event){
      this.registeredCallbacks[event.component] = event.callback;
    },
    firstLoad: function(){
      this.clearData();
      if(this.visibles[0]!=5){ //se il primo step è "Selezione Catalogo" il caricamento viene gestito nel suo mounted 
        //il controllo sulla presenza o meno di un catalogo pre-caricato è stato spostato in App.vue, in cui vengono settati i seguenti flag 
        if (this.$root.openModalSelect) {
          //LOAD AFTER LOGIN
          this.$refs.modal.open();
          if((this.$Behaviors.loadFirstCatalog || (this.$Behaviors.loadCatalogIfOne && this.$Configs.catalogs.length == 1)) && (this.$Configs.idAgente == null || this.$Configs.idAgente == 'null')){
            // nascondo il loader se carico il catalogo senza iterazione dell'utente
            $("#m-wrap > .sweet-modal-overlay").css("visibility", "hidden");
            this.childrenContent.catalogo = this.$Configs.catalogs[0].id
            this.childrenContent.fileName = this.$Configs.catalogs[0].file
            this.load();
          }
        } else if (this.$root.emitGotIndex) {
          eventBus.$emit("gotIndex");
        }
      }else{
        if (this.$root.emitGotIndex && !this.$root.openModalSelect) {
          eventBus.$emit("gotIndex");
        }
      }
    },
    //router per l'instradamento nella procedura di caricamento
    stepForward: function(e) {
      this.exOnOpen = false;

      // se il componente Step riporta delle informazioni, le salvo in childrenContent
      if (e.override != null) {
        for (var prop in e.override) {
          this.childrenContent[prop] = e.override[prop];
        }
      }
      if(this.childrenContent.modello == null){
        //se non ho selezionato il modello, ripulisco il form della ricerca
        eventBus.$emit('clearForm')
      }
      this.$root.clientSelected = this.childrenContent.idCliente;
      
      if(this.$root.clientSelected && e.functionName == 'load_first_or_parameter')eventBus.$emit('clientSelected')

      // se il componente Step indica un passo specifico, lo faccio immediatamente
      if (e.step != null) {
        this.changeStep(e.step);
      }
      // se il componente Step indica una funzione per il controllo di una condizione, la eseguo
      if (e.functionName != null && e.functionName.trim() != "") {
        try {
          this[e.functionName](e.functionParameter); //chiamo la funzione passata dallo step
        } catch (err) {
          console.log(
            "Error on trying execute " +
              e.functionName +
              "(" +
              e.functionParameter +
              ")"
          );
          console.log(err);
        }
      }
    },
    navBackward: function() {
      var backTo = this.previous_step.pop();
      this.changeStep(backTo, true);
    },
    //gates methods
    load_first_or_parameter: function() {
      if (this.$Behaviors.loadFirstCatalog || (this.$Configs.catalogs && this.$Configs.catalogs > 0)) {
        this.load_from_client_catalog_list();
      } else {
        this.exists_serial_reference();
      }
    },
    exists_serial_reference: function() {
      if (
        this.$Behaviors.requestUpdateReference &&
        this.$Behaviors.machineIdMustExists &&
        this.$Behaviors.updatesReference == "serial"
      ) {
        this.changeStep(2);
      } else {
        this.load_from_client_catalog_list();
      }
    },
    load_from_client_catalog_list: function(editVisibleBool) {
      if (editVisibleBool) {
        this.secondSlice();
      }
      this.changeStep(5);
    },
    changeStep: function(s, ignorePreviousRecording) {
      var i = this.visibles.indexOf(s);
      if (i == -1) {
        this.visibles.push(s);
      }

      if (ignorePreviousRecording != true) {
        this.previous_step.push(this.step);
      }
      this.step = s;
    },
    load: function() {
      var index_as_root;
      if(this.childrenContent.categoria){
        index_as_root = this.childrenContent.categoria
        this.$root.model_of_cat = this.childrenContent.modello 
      }else{
        index_as_root = null; // MODELLI
        this.$root.model_of_cat = null;
      }
      var id = this.childrenContent.catalogo;
      //this.childrenContent = {}
      if (id != null) {
        this.$root.root_index = id;
        this.$root.index_as_root = index_as_root != null ? index_as_root : "MODELLI";
        this.$root.root_filename = this.childrenContent.fileName;
        localStorage.setItem("current_root", this.$root.root_index);
        localStorage.setItem("current", this.$root.index_as_root);
        localStorage.setItem("current_name", this.$root.root_filename);
        if(this.$root.model_of_cat){
          localStorage.setItem("current_loaded_model", this.$root.model_of_cat);
        } else {
          localStorage.removeItem("current_loaded_model");
        }

        if(this.$Behaviors.updatesReference == "date"){
          if(!this.$root.validity){
            this.$root.validity = new Date()
          }
          eventBus.$emit("date", this.$root.validity)
        } else if(this.$root.model_of_cat == null){
           this.$root.validity = null;
           sessionStorage.removeItem("validity");
        }
        
        eventBus.$emit("gotIndex");
        this.$refs.modal.close();
      } else {
        console.log("NULL CATALOG!! was alert")
        alert('CATALOG MISSING')
      }
    },
    //Utilities
    stepLabel: function(item) {
      return item.Descrizione;
    },
    stepValue: function(item){
      if(item.ID == 1)return this.childrenContent.ragioneSociale
      if(item.ID == 5)return this.childrenContent.nomeCatalogo
      if(item.ID == 6)return this.childrenContent.descrizioneModello
    },
    clearData: function() {
      this.step = this.visibles[0];

      this.active = {
        id: -1,
        nome: ""
      };
      this.committing = {
        id: -1,
        nome: ""
      };
      this.doBlock = true;
      this.exOnOpen = false;
    }
  }
};
</script>

<style scoped>
  #step_wrapper {
    border-bottom: 1px solid #090c0f;
    box-shadow: 0px 1px 0px #273442;
    margin-bottom: 15px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 8px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 0px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #374850;
  }
</style>

<style>
  div.sweet-modal {
    overflow: hidden;
  }

  div.sweet-content {
    padding: 0px !important;
  }
  /* with dark mmodal theme
  div.sweet-content .slot-button {
    border-top: 1px solid #273442;
    box-shadow: 0px -1px 0px #090c0f;
    padding-top: 16px;
    margin-top: 16px;
    text-align: right;
  }
  */
  div.sweet-content .slot-button {
    border-top: 1px solid white;
    box-shadow: 0px -1px 0px lightgrey;
    padding-top: 16px;
    margin-top: 16px;
    text-align: right;
  }

  .slot-button > button {
    width: 85px;
    margin: 0px 5px;
  }

  .modal-menu {
    max-height: 200px !important;
    overflow-y: auto !important;
    margin: 0px 10px !important;
    border-radius: 2px !important;
  }

  .modal-menu li {
    text-align: left !important;
    color: black !important;
    background-color: white !important;
    border-radius: 0px !important;
    padding: 6px 15px !important;
    font-size: 13px !important;
    border-bottom-style: solid;
    border-width: thin;
    border-color: #374850;
  }

  .modal-menu li.active,
  .modal-menu li:hover {
    cursor: pointer;
    color: white !important;
    background-color: #039be5 !important;
  }

  .alert-select {
    color: white !important;
    background-color: #374850 !important;
    border-color: #999 !important;
  }

  div.sweet-content .btn-default {
    background-color: #374850 !important;
    color: white !important;
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    animation: slide-in 0.5s ease-out forwards;
    transition: opacity 0.5s;
  }

  .fade-leave-active {
    animation: slide-out 0.5s ease-out forwards;
    transition: opacity 0.5s;
    opacity: 0;
    position: absolute;
  }

  .fade-move {
    transition: transform 0.5s;
  }

  @keyframes slide-in {
    from {
      transform: translateX(-150px);
    }
    to {
      transform: translateX(0px);
    }
  }

  @keyframes slide-out {
    from {
      transform: translateX(0px);
    }
    to {
      transform: translateX(150px);
    }
  }

  /* common css for step children*/
  #step_component_wrapper .slot-content {
    padding: 12px;
  }

  #step_component_wrapper .slot-button {
    padding: 12px;
    width: 100%;
    float: right;
  }

  #step_component_wrapper .v-select.open {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  button.btn-primary-default,
  button.btn-primary-default:hover {
    color: white !important;
    background-color: #337ab7;
    border-color: #2e6da4;
  }
</style>



// WEBPACK FOOTER //
// src/components/loader/ModalSelect.vue?b59e3c68